import { render, staticRenderFns } from "./PtServicePage.vue?vue&type=template&id=846ea4c2"
import script from "./PtServicePage.vue?vue&type=script&lang=ts"
export * from "./PtServicePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports